import { r as registerInstance, c as createEvent, h, H as Host } from './index-1d3c5472.js';

const patternlibToastCss = "*,::before,::after{box-sizing:border-box;border-width:0;border-style:solid;border-color:var(--color-steel-200)}::before,::after{--tw-content:''}html{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;-o-tab-size:4;tab-size:4;font-family:ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\"}body{margin:0;line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-0.25em}sup{top:-0.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;font-weight:inherit;line-height:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,[type='button'],[type='reset'],[type='submit']{-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type='search']{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{list-style:none;margin:0;padding:0}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{opacity:1;color:var(--color-steel-400)}input::placeholder,textarea::placeholder{opacity:1;color:var(--color-steel-400)}button,[role=\"button\"]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}[hidden]{display:none}*,::before,::after{--tw-border-spacing-x:0;--tw-border-spacing-y:0;--tw-translate-x:0;--tw-translate-y:0;--tw-rotate:0;--tw-skew-x:0;--tw-skew-y:0;--tw-scale-x:1;--tw-scale-y:1;--tw-scroll-snap-strictness:proximity;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:rgb(59 130 246 / 0.5);--tw-ring-offset-shadow:0 0 #0000;--tw-ring-shadow:0 0 #0000;--tw-shadow:0 0 #0000;--tw-shadow-colored:0 0 #0000;}::backdrop{--tw-border-spacing-x:0;--tw-border-spacing-y:0;--tw-translate-x:0;--tw-translate-y:0;--tw-rotate:0;--tw-skew-x:0;--tw-skew-y:0;--tw-scale-x:1;--tw-scale-y:1;--tw-scroll-snap-strictness:proximity;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:rgb(59 130 246 / 0.5);--tw-ring-offset-shadow:0 0 #0000;--tw-ring-shadow:0 0 #0000;--tw-shadow:0 0 #0000;--tw-shadow-colored:0 0 #0000;}.filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}:host{display:block}";

const PatternlibToast = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.close = createEvent(this, "lhClose", 7);
    this.undo = createEvent(this, "lhUndo", 7);
    this.toasts = [];
    this.toastItemsHeights = {};
    this.storedToasts = [];
    this.position = 'bottom-left';
    this.width = '408px';
  }
  /**
   * Public function to create toast item
   */
  async createToastItem(toast) {
    const newToast = {
      itemId: toast.itemId != null ? toast.itemId : this.getItemId(),
      message: toast.message,
      subline: toast.subline !== null ? toast.subline : '',
      type: toast.type != null ? toast.type : 'default',
      showIcon: toast.showIcon != null ? toast.showIcon : false,
      autoHide: toast.autoHide != null ? toast.autoHide : false,
      showUndo: toast.showUndo != null ? toast.showUndo : false,
      delay: toast.delay != null ? toast.delay : 3000,
    };
    const filteredToasts = this.toasts.filter(item => item.itemId === newToast.itemId);
    if (filteredToasts.length > 0) {
      throw new Error('[patternlib-toast] The same itemId is not allowed twice!');
    }
    else {
      this.toasts.push(newToast);
      this.storedToasts = [...this.toasts];
      // If the autoHide property is set the toast will be deleted after x ms
      if (newToast.autoHide) {
        setTimeout(() => {
          this.close.emit({ itemId: newToast.itemId });
          delete this.toastItemsHeights[newToast.itemId];
          this.toasts.forEach((item, index) => {
            if (item.itemId === newToast.itemId) {
              this.toasts.splice(index, 1);
              if (this.toasts.length === 0) {
                this.storedToasts = [];
              }
              else {
                this.storedToasts = [...this.toasts];
              }
            }
          });
        }, newToast.delay);
      }
    }
  }
  /**
   * Listen if a toast gets closed
   */
  async handleOnClose(e) {
    const itemId = e.detail.itemId;
    this.close.emit({ itemId: itemId });
    delete this.toastItemsHeights[itemId];
    this.toasts.forEach((item, index) => {
      if (item.itemId === itemId) {
        this.toasts.splice(index, 1);
        if (this.toasts.length === 0) {
          this.storedToasts = [];
        }
        else {
          this.storedToasts = [...this.toasts];
        }
      }
    });
  }
  getItemId() {
    return Math.random().toString(36).substring(2, 9);
  }
  /**
   * Listen if an undo button gets clicked
   */
  handleOnUndo(e) {
    const itemId = e.detail.itemId;
    this.undo.emit({ itemId: itemId });
    delete this.toastItemsHeights[itemId];
    this.toasts.forEach((item, index) => {
      if (item.itemId === itemId) {
        this.toasts.splice(index, 1);
        if (this.toasts.length === 0) {
          this.storedToasts = [];
        }
        else {
          this.storedToasts = [...this.toasts];
        }
      }
    });
  }
  handleToastItemRendered(evt) {
    if (this.toastItemsHeights === undefined) {
      this.toastItemsHeights = { [evt.detail.itemId]: evt.detail.domRef.getBoundingClientRect().height };
      return;
    }
    if (this.toastItemsHeights[evt.detail.itemId] === undefined) {
      this.toastItemsHeights = Object.assign(Object.assign({}, this.toastItemsHeights), { [evt.detail.itemId]: evt.detail.domRef.getBoundingClientRect().height });
    }
  }
  getToastItemsHeightSum(lastIndex) {
    let sumHeights = 0;
    const gap = 12;
    if (this.toastItemsHeights !== undefined) {
      this.storedToasts.forEach((item, index) => {
        const height = this.toastItemsHeights[item.itemId];
        if (index < lastIndex) {
          sumHeights += height + gap;
        }
      });
    }
    return sumHeights;
  }
  render() {
    var _a;
    const initialHeight = 32;
    return (h(Host, null, (_a = this.storedToasts) === null || _a === void 0 ? void 0 : _a.map((item, index) => {
      return (h("patternlib-toast-item", { message: item.message, subline: item.subline, "item-id": item.itemId, show: true, height: this.toastItemsHeights !== undefined ? `${this.toastItemsHeights[item.itemId]}px` : undefined, "animation-value": index === 0 ? `${initialHeight}px` : `${initialHeight + this.getToastItemsHeightSum(index)}px`, type: item.type, "show-icon": item.showIcon, "auto-hide": item.autoHide, "show-undo": item.showUndo, delay: item.delay, position: this.position, width: this.width }));
    })));
  }
};
PatternlibToast.style = patternlibToastCss;

export { PatternlibToast as patternlib_toast };
